/**
 * Progressive hero video: show first frame as poster, play when buffered.
 */
export function initHeroVideos() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const saveData = connection?.saveData === true;

  if (prefersReducedMotion || saveData) {
    return;
  }

  document.querySelectorAll('[data-hero-video]').forEach((wrapper) => {
    const video = wrapper.querySelector('video[data-hero-video-file]');
    if (!video) {
      return;
    }

    video.preload = 'auto';

    video.addEventListener(
      'canplay',
      () => {
        video.play().catch(() => {});
      },
      { once: true },
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroVideos);
} else {
  initHeroVideos();
}
